<template>
  <div class="v-listing-options-loading" />
</template>

<script>
export default {
  name: "v-listing-options-loading"
};
</script>
